<template>
  <div class="new-user-form__advanced-details-form">
    <div
      class="advanced-details-form__header cursor-pointer"
      @click="showAdvancedDetailsForm"
    >
      <div>
        <p class="text-secondary-orange font-semibold">Advanced Details</p>
      </div>
      <div class="line-wrapper">
        <hr />
      </div>
      <div :class="{ open: isAdvancedForm }" class="dropdown-icon">
        <svg
          width="14"
          height="7"
          viewBox="0 0 10 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 1.03467L5 5.03467L9 1.03467"
            stroke="#F57A4D"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
    <div
      :class="{ show: isAdvancedForm }"
      class="advanced-details-form__main"
      ref="advancedDetails"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4 col-lg-4 col-12">
            <div class="advanced-details__form-input-wrapper">
              <label for="functiob" class="label">Function</label>
              <input type="text" class="input-field" />
            </div>
          </div>
          <div class="col-md-4 col-lg-4 col-12">
            <div class="advanced-details__form-input-wrapper">
              <label for="designation" class="label">Designation</label>
              <input type="text" class="input-field" />
            </div>
          </div>
          <div class="col-md-4 col-lg-4 col-12">
            <div class="advanced-details__form-input-wrapper">
              <label for="reporting-line" class="label">Reporting Line</label>
              <input type="text" class="input-field" />
            </div>
          </div>
          <div class="col-md-4 col-lg-4 col-12">
            <div class="advanced-details__form-input-wrapper">
              <label for="user-level" class="label">User Level</label>
              <input type="text" class="input-field" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isAdvancedForm: false,
    };
  },
  methods: {
    showAdvancedDetailsForm() {
      let content = this.$refs.advancedDetails;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
        content.style.marginBottom = null;
      } else {
        content.style.maxHeight = content.scrollHeight + 6 + "px";
        content.style.marginBottom = "1rem";
      }
      this.isAdvancedForm = !this.isAdvancedForm;
    },
  },
};
</script>

<style scoped>
.advanced-details-form__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 0;
}
.label {
  font-size: 0.9rem;
}
.input-field {
  display: block;
  width: 100%;
  height: 2.75rem;
  margin-bottom: 0.5rem;
  background: #fafafd;
  border: 0.5px solid #c5d1e6;
  box-sizing: border-box;
  border-radius: 4px;
}
hr {
  display: inline-block;
}
.button-wrapper {
  padding: 2rem 15px;
}
.advanced-details-form__main {
  max-height: 0;
  overflow: hidden;
  transition: all ease 0.5s;
}
.advanced-details-form__main.show {
  height: auto;
}
.dropdown-icon {
  transition: all ease 0.5s;
}
.dropdown-icon.open {
  transform: rotate(180deg);
}
</style>
